import React from 'react';
import { Select } from 'antd';
import { useI18n } from '../i18n/I18nContext';

function LanguageSwitcher({ size = 'middle', style }) {
  const { locale, setLocale, t } = useI18n();

  return (
    <Select
      size={size}
      value={locale}
      onChange={setLocale}
      style={{ minWidth: 110, ...style }}
      options={[
        { value: 'en', label: t('lang.en') },
        { value: 'zh', label: t('lang.zh') },
      ]}
      aria-label={t('lang.label')}
    />
  );
}

export default LanguageSwitcher;
